import { Link, NavLink, useLocation } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import { useAdmin } from "../hooks/useAdmin";

// Mostra um nav diferente baseado na rota. /admin/* recebe o admin-nav, todo
// o resto recebe o store-nav. Os dois são totalmente independentes — nenhum
// link cruzado nem badges do outro contexto.
export function Nav() {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");
  return isAdminRoute ? <AdminNav /> : <StoreNav />;
}

function StoreNav() {
  const { user, logout } = useUser();
  return (
    <nav className="top-nav">
      <Link to="/" className="brand">
        <strong>ICL Pagamentos</strong>
        <span className="brand-tag">sandbox</span>
      </Link>
      <div className="nav-links">
        <NavLink to="/loja" className={({ isActive }) => (isActive ? "active" : "")}>
          Loja
        </NavLink>
        <NavLink to="/conta" className={({ isActive }) => (isActive ? "active" : "")}>
          Minha Conta
        </NavLink>
      </div>
      <div className="nav-user">
        {user ? (
          <>
            <span className="user-info">
              <strong>{user.name ?? user.email}</strong>
              <small>#{user.id}</small>
            </span>
            <button onClick={logout} className="ghost-btn">
              Sair
            </button>
          </>
        ) : (
          <Link to="/login" className="login-link">
            Entrar
          </Link>
        )}
      </div>
    </nav>
  );
}

function AdminNav() {
  const { admin, logout } = useAdmin();
  return (
    <nav className="top-nav admin-nav">
      <Link to={admin ? "/admin" : "/admin/login"} className="brand">
        <strong>ICL Pagamentos</strong>
        <span className="brand-tag">admin</span>
      </Link>
      <div className="nav-links">
        {admin && (
          <NavLink to="/admin" end className={({ isActive }) => (isActive ? "active" : "")}>
            Dashboard
          </NavLink>
        )}
      </div>
      <div className="nav-user">
        {admin ? (
          <>
            <span className="user-info">
              <strong>{admin.name ?? admin.email}</strong>
              <small>admin</small>
            </span>
            <button onClick={logout} className="ghost-btn">
              Sair
            </button>
          </>
        ) : null}
      </div>
    </nav>
  );
}
